import React from 'react';
import { Link } from 'react-router-dom';
import { Headphones, Instagram, Youtube, Facebook, Mail, ShieldCheck } from 'lucide-react';

export const Footer = () => {
    

    return (
        <footer className="bg-nature-100 border-t border-nature-200 mt-24">
            <div className="max-w-7xl mx-auto px-6 py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    {/* Brand */}
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="w-10 h-10 rounded-full bg-nature-800 flex items-center justify-center">
                                <Headphones className="w-5 h-5 text-nature-50" />
                            </div>
                            <div>
                                <span className="font-heading text-lg font-semibold text-nature-900 block">
                                    Hypnosis Mastery Series
                                </span>
                                <span className="text-xs text-nature-800/60 font-body">
                                    Single hypnosis sessions for a mind that won't switch off.
                                </span>
                            </div>
                        </div>
                        <p className="text-nature-800/70 font-body text-sm leading-relaxed">
                            Guided hypnosis recordings designed to release stress, dissolve limiting patterns, 
                            and restore calm confidence and emotional balance.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-heading text-nature-900 font-semibold mb-4">Quick Links</h4>
                        <ul className="space-y-2">
                            <li>
                                <Link 
                                    to="/recordings" 
                                    className="text-nature-800/70 hover:text-copper-500 transition-colors font-body text-sm"
                                    data-testid="footer-recordings"
                                >
                                    All Recordings
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/is-this-for-me" 
                                    className="text-nature-800/70 hover:text-copper-500 transition-colors font-body text-sm"
                                    data-testid="footer-is-this-for-me"
                                >
                                    Is This For Me?
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/blog" 
                                    className="text-nature-800/70 hover:text-copper-500 transition-colors font-body text-sm"
                                    data-testid="footer-blog"
                                >
                                    Blog
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/about" 
                                    className="text-nature-800/70 hover:text-copper-500 transition-colors font-body text-sm"
                                    data-testid="footer-about"
                                >
                                    About Eric Paris
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/custom-recording" 
                                    className="text-nature-800/70 hover:text-copper-500 transition-colors font-body text-sm"
                                    data-testid="footer-custom-recording"
                                >
                                    Custom recording
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/cart" 
                                    className="text-nature-800/70 hover:text-copper-500 transition-colors font-body text-sm"
                                    data-testid="footer-cart"
                                >
                                    Your Cart
                                </Link>
                            </li>
                        </ul>
                        
                        {/* Free Session CTA */}
                        <div className="mt-6 pt-4 border-t border-nature-200">
                            <Link 
                                to="/recording/freedom-from-insomnia"
                                className="text-copper-600 hover:text-copper-700 transition-colors font-body text-sm font-medium cursor-pointer"
                                data-testid="footer-free-session"
                            >
                                Not ready to choose? Try a full free session for sleep.
                            </Link>
                        </div>
                    </div>

                    {/* Social */}
                    <div>
                        <h4 className="font-heading text-nature-900 font-semibold mb-4">Connect</h4>
                        
                        {/* Contact Email */}
                        <a 
                            href="mailto:contact@hypnosismasteryseries.com" 
                            className="flex items-center gap-2 text-nature-800/70 hover:text-copper-500 transition-colors font-body text-sm mb-4"
                            data-testid="footer-email"
                        >
                            <Mail className="w-4 h-4" />
                            contact@hypnosismasteryseries.com
                        </a>
                        
                        <p className="text-nature-800/70 font-body text-sm mb-4">
                            Explore free samples on social media
                        </p>
                        <div className="flex gap-3">
                            <a 
                                href="https://instagram.com/hypnosismasteryseries" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full bg-nature-200 hover:bg-copper-500 hover:text-white flex items-center justify-center transition-all"
                                data-testid="social-instagram"
                            >
                                <Instagram className="w-5 h-5" />
                            </a>
                            <a 
                                href="https://www.youtube.com/@hypnosismasteryseries" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full bg-nature-200 hover:bg-copper-500 hover:text-white flex items-center justify-center transition-all"
                                data-testid="social-youtube"
                            >
                                <Youtube className="w-5 h-5" />
                            </a>
                            <a 
                                href="https://facebook.com/hypnosismasteryseries" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full bg-nature-200 hover:bg-copper-500 hover:text-white flex items-center justify-center transition-all"
                                data-testid="social-facebook"
                            >
                                <Facebook className="w-5 h-5" />
                            </a>
                        </div>
                        
                        {/* Money-Back Guarantee */}
                        <div className="mt-6 p-4 bg-nature-50 rounded-xl border border-nature-200">
                            <div className="flex items-center gap-2 text-nature-900 mb-1">
                                <ShieldCheck className="w-5 h-5 text-copper-500" />
                                <span className="font-heading font-semibold text-sm">30-Day Money-Back Guarantee</span>
                            </div>
                            <p className="text-nature-800/60 font-body text-xs">
                                Not satisfied? Get a full refund, no questions asked.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="border-t border-nature-200 mt-12 pt-8 text-center">
                    <p className="text-nature-800/50 font-body text-xs leading-relaxed max-w-3xl mx-auto mb-4">
                        Disclaimer: These hypnosis recordings are designed for relaxation and personal development purposes only. 
                        They are not intended to diagnose, treat, or cure any medical or psychological condition. 
                        If you are experiencing serious mental health concerns, please consult a qualified healthcare professional.
                    </p>
                    <p className="text-nature-800/50 font-body text-sm">
                        © {new Date().getFullYear()} Hypnosis Mastery Series by Eric Paris. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
